var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 2.09792C0.25 1.79954 0.368528 1.51339 0.579509 1.30241C0.79049 1.09143 1.07664 0.9729 1.37502 0.9729H14.8752C15.1736 0.9729 15.4597 1.09143 15.6707 1.30241C15.8817 1.51339 16.0002 1.79954 16.0002 2.09792V5.47296C16.0001 5.77131 15.8816 6.05741 15.6706 6.26835L10.3751 11.5638V15.5981C10.3751 15.8964 10.2565 16.1825 10.0455 16.3935L7.79548 18.6435C7.63814 18.8008 7.4377 18.9079 7.2195 18.9513C7.0013 18.9947 6.77514 18.9724 6.5696 18.8873C6.36406 18.8021 6.18837 18.658 6.06475 18.473C5.94113 18.2881 5.87512 18.0706 5.87508 17.8481V11.5638L0.579629 6.26835C0.368634 6.05741 0.250064 5.77131 0.25 5.47296V2.09792Z",
    fill: "#8F38EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.5fdec5ee2d4e0c66bbfa28db57035dcc.svg";
export { ForwardRef as ReactComponent };